'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageWarning = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(MessageWarning, _React$PureComponent);

    function MessageWarning() {
        (0, _classCallCheck3.default)(this, MessageWarning);
        return (0, _possibleConstructorReturn3.default)(this, (MessageWarning.__proto__ || (0, _getPrototypeOf2.default)(MessageWarning)).apply(this, arguments));
    }

    (0, _createClass3.default)(MessageWarning, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                text = _props.text,
                icon = _props.icon;

            return _react2.default.createElement(
                'div',
                { className: 'cart__warning' },
                _react2.default.createElement(
                    'span',
                    { className: 'cart-w__icon' },
                    _react2.default.createElement('i', { className: icon })
                ),
                _react2.default.createElement('span', { className: 'warning__message', dangerouslySetInnerHTML: { __html: text } })
            );
        }
    }]);
    return MessageWarning;
}(_react2.default.PureComponent), _class.propTypes = {
    text: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string
}, _temp);
exports.default = MessageWarning;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/MessageWarning.js
// module id = 748
// module chunks = 0